import { MonthRangePicker } from 'app/components/common/DatePickers';
import { useStore } from 'app/context';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';

export const SocialMediaBmRangeOptions = observer(() => {
	const { agtSocialMediaUiStore } = useStore();

	const onMinChange = (value: number) => {
		runInAction(() => {
			agtSocialMediaUiStore.rangeMinBm = value;
		});
	};

	const onMaxChange = (value: number) => {
		runInAction(() => {
			agtSocialMediaUiStore.rangeMaxBm = value;
		});
	};

	return (
		<MonthRangePicker
			minValue={agtSocialMediaUiStore.selectedMinBm}
			maxValue={agtSocialMediaUiStore.selectedMaxBm}
			opts={agtSocialMediaUiStore.bmOpts}
			onMinChange={onMinChange}
			onMaxChange={onMaxChange}
			emptyTextMin="Start Monat"
			emptyTextMax="End Monat"
			queryParam="bm"
		/>
	);
});

export const LinkedinBmRangeOptions = observer(() => {
	const { agtLinkedinUiStore } = useStore();

	const onMinChange = (value: number) => {
		runInAction(() => {
			agtLinkedinUiStore.rangeMinBm = value;
		});
	};

	const onMaxChange = (value: number) => {
		runInAction(() => {
			agtLinkedinUiStore.rangeMaxBm = value;
		});
	};

	return (
		<MonthRangePicker
			minValue={agtLinkedinUiStore.selectedMinBm}
			maxValue={agtLinkedinUiStore.selectedMaxBm}
			opts={agtLinkedinUiStore.bmOpts}
			onMinChange={onMinChange}
			onMaxChange={onMaxChange}
			emptyTextMin="Start Monat"
			emptyTextMax="End Monat"
			queryParam="bm"
		/>
	);
});
